import axios from 'axios'

export default {
    getAll: () => axios.get(`/customer`),
    getAllTelegram: () => axios.get(`/customer/telegram`),
    getById: id => axios.get(`/customer/${id}`),
    getTelegramById: id => axios.get(`/customer/telegram/${id}`),
    getAllBirthday: () => axios.get(`/customer/birthday`),
    searchByPhone: formData => axios.post(`/customer/search`, formData),
    searchByName: formData => axios.post(`/customer/telegram/search`, formData)
}
